import { CloudRain } from "lucide-react";

export const ClimateIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3983 15.4133V5.15224C16.3983 3.51702 15.0492 2.16797 13.414 2.16797C11.7788 2.16797 10.4297 3.51702 10.4297 5.15224V15.4133C9.32596 16.3126 8.67188 17.6617 8.67188 19.0925C8.67188 21.7089 10.7977 23.8346 13.414 23.8346C16.0304 23.8346 18.1561 21.7089 18.1561 19.0925C18.1153 17.6617 17.502 16.3126 16.3983 15.4133ZM13.414 22.8535C11.37 22.8535 9.69389 21.1774 9.69389 19.0925C9.69389 17.907 10.2662 16.7623 11.2473 16.0674L11.4517 15.9038V5.15224C11.4517 4.04847 12.3511 3.1491 13.4549 3.1491C14.5587 3.1491 15.458 4.04847 15.458 5.15224V15.9038L15.6624 16.0674C16.6436 16.7623 17.2159 17.907 17.2159 19.0925C17.1341 21.1774 15.458 22.8535 13.414 22.8535Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
      <path
        d="M14.1339 17.4899V9.60859C14.1339 9.24508 13.8004 8.9375 13.4063 8.9375C13.0121 8.9375 12.6786 9.24508 12.6786 9.60859V17.4899C11.8904 17.7695 11.375 18.4686 11.375 19.2515C11.375 20.2861 12.2845 21.125 13.4063 21.125C14.528 21.125 15.4375 20.2861 15.4375 19.2515C15.4375 18.4406 14.9221 17.7695 14.1339 17.4899Z"
        fill={color}
      />
    </svg>
    // <CloudRain
    //   strokeWidth={1.5}
    //   stroke="var(--color-planet-green)"
    //   // fill="var(--color-planet-green)"
    // />
  );
};

export default ClimateIcon;
